<template>
	<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
	<div :class="expand ? 'text-primary collapsible' : 'text-primary collapsible collapsed'">
		<div class="collapsible-heading p-0">
			<div class="d-flex bottom-border">
				<div :class="companyColor" @click="onToggleExpand">{{label}}</div>
				<div :class="companyColorDropdownIcon">
					<b-button href="#" variant="collapsible" :class="expand ? '' : ' collapsed'" :aria-expanded="expand ? 'true' : 'false'" :aria-controls="'collapseListing-'+metaKey" @click="onToggleExpand">
						<span class="when-opened">
							<font-awesome-icon icon="chevron-down" />
						</span>
						<span class="when-closed">
							<font-awesome-icon icon="chevron-right" />
						</span>
					</b-button>
				</div>
			</div>
		</div>
		<b-collapse :id="'collapseListing-'+metaKey" :visible="expand" class="collapse--content">
			<b-col>
				<b-form-group id="'ig-setting'+metaKey" label-for="'input-lcr-setting'+metaKey" description="">
					<div class="setting__description">{{description}}</div>
					<div v-if="value.length > 0" class="setting__users">
						<b-form-row v-for=" (setting, index) in value" class="setting" v-bind:key="'cedit'+'-'+index+'-'+Math.random()">
							<b-col cols="8">
								<div class="setting__name">{{setting.firstName}} {{setting.lastName}}</div>
								<div class="setting__organization">{{setting.organizationName}}</div>
								<div class="setting__phone">{{setting.phone}}</div>
							</b-col>
							<b-col cols="4" class="text-right ">
								<b-button variant="light-blue" type="button" class="btn-sm mt-3" @click="onRemove(index)">Remove</b-button>
							</b-col>
						</b-form-row>
					</div>
					<div v-if="value.length == 0"  class="setting__users">
						<strong>No {{label}} users are assigned.</strong>
					</div>
					<autocomplete data-position="above" :search="onSearch" @submit="onSelect" placeholder="Start typing to select user" aria-label="Start typing to select user" :ref="metaKey" auto-select>
						<template v-slot:result=" {result, props } ">
							<li v-bind="props" class="autocomplete-result -setting-result">
								<div class="autocomplete__name">{{result.firstName}} {{result.lastName}}</div>
								<div v-if="result.organizationName" class="autocomplete__organization">{{result.organizationName}}</div>
								<div v-if="result.phone" class="autocomplete__phone">{{result.phone}}</div>
							</li>
						</template>
					</autocomplete>
				</b-form-group>

			</b-col>
		</b-collapse>

	</div>

</template>

<script>
import Autocomplete from '@trevoreyre/autocomplete-vue'
import Vue from 'vue'

export default {
	name: 'GlobalSettingContact',
	props: ['value','label', 'metaKey', 'description', 'expanded'],
	data() {
		return {
			expand:false,
		}
	},
	components:{
	Autocomplete
	},
	mounted() {
   },
   watch: {
   },
	computed: {
		companyColor() {
			return "flex-grow-1 bg-primary-x-light collapsible-heading__value color-column";
		},
		companyColorDropdownIcon() {
			return "bg-primary-x-light collapsible-heading__toggle";
		},
	},
	methods: {
		onExpand() {
			this.expand = true;
		},
		onCollapse() {
			this.expand = false;
		},

		onToggleExpand() {
			this.expand = !this.expand
		},
		// Alternate Requesters
		onSearch(input) {
			return new Promise((resolve, reject) => {
				if (input.length < 1) {
					return resolve([])
				}
				Vue.prototype.$http.get(this.$store.state.apiUrl + '/organization/users/assignable?meta_key='+encodeURI(this.metaKey)+'&q=' + encodeURI(input))
					.then(resp => {
						resolve(resp.data)
					})
					.catch(error => {
						reject(error)
					})
			})
		},
		onSelect(selected) {
			// add the selected setting to the  listing, with a delete button as well.
			if (selected) {
				let found = false;
				for (var entry in this.value) {
					if (this.value[entry].userId == selected.userId) {
						// already in the list.
						found = true;
					}
				}
				if (!found) {
					// this.value.push(selected);
					this.$emit("update:add", selected);
					this.$refs[this.metaKey].value = null;
					// this.$refs[this.metaKey+'Limited'].value = null;
				}
			}
			this.$refs[this.metaKey].value = null;
		},
		onRemove(index) {
			this.$emit("update:remove", index);
		},
	}
}

</script>
